<template>
    <div style="position: relative">
        <vTable
            class="margin-15"
            :columns="columns"
            :data="datalist"
            size="small"
            ref="tableaontact"
            border
        ></vTable>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import {
    HttpGetTransPoDetail,
    HttpGetOrderOne,
} from "@/service/purchase/purchase";

export default {
    props: ["poId", "appid", "comorderno"],
    data() {
        return {
            datalist: [],
            currency: "",
            loading: false,
        };
    },
    created() {
        this.update();
    },
    watch: {
        comorderno() {
            this.update();
        },
    },
    computed: {
        columns() {
            return [
                {
                    title: "ERPSKU",
                    key: "erpsku",
                },
                {
                    title: this.$t("boss.purchase.number_transfer_orders", {
                        defaultValue: "转单数量",
                    }),
                    key: "quantity",
                },
                {
                    title: this.$t("boss.purchase.unit_price", {
                        defaultValue: "单价",
                    }),
                    key: "price",
                },
                {
                    title: this.$t("boss.purchase.currency", {
                        defaultValue: "币种",
                    }),
                    key: "currency",
                },
            ];
        },
    },
    methods: {
        update() {
            this.loading = true;
            HttpGetOrderOne({
                id: this.poId,
            }).then(
                (res) => {
                    this.currency = res.data.currency;
                    HttpGetTransPoDetail({
                        poRequistionId: this.appid,
                        poOrderId: this.poId,
                    }).then(
                        (res) => {
                            res.data.map((item) => {
                                let dataone = {
                                    erpsku: item.erpsku,
                                    quantity: item.quantity,
                                    price: item.price,
                                    currency: this.currency,
                                };
                                this.datalist.push(dataone);
                            });
                            this.loading = false;
                        },
                        (err) => {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                            this.loading = false;
                        }
                    );
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
    },
};
</script>
